import { render, staticRenderFns } from "./zfbDialog.vue?vue&type=template&id=b86a722e&scoped=true&"
import script from "./zfbDialog.vue?vue&type=script&lang=js&"
export * from "./zfbDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86a722e",
  null
  
)

export default component.exports